const enterprise = {
  title: 'Cilium - Enterprise Distributions & Training Partners',
  description:
    'Learn how to get enterprise level support and training for Cilium from different vendors in the ecosystem',
};
const homepage = {
  title: 'Cilium - eBPF-based Networking, Observability, and Security for Kubernetes',
  description: 'Cilium provides eBPF-based networking, observability, and security for Kubernetes and beyond. Trusted by all major cloud providers and cloud native platforms worldwide.',
};
const learn = {
  title: 'Cilium - What is Cilium?',
  description:
    'Cilium is an open source project to provide networking, security, and observability for cloud native environments such as Kubernetes clusters and other container orchestration platforms.',
};
const adopters = {
  title: 'Cilium users and real world case studies',
  description:
    'Discover who is using Cilium in production, their use case, and where you can deploy Cilium',
};

const brand = {
  title: 'Cilium brand guidelines',
  description: 'Cilium brand guidelines to help you use our brand and assets',
};

const getHelp = {
  title: 'Find out how to get help with Cilium',
  description: 'Get help with Cilium through slack, training, support, and FAQs',
};

const getInvolved = {
  title: 'Get involved in the Cilium community',
  description:
    'Learn how to follow, develop, and contribute to the Cilium community through Slack, Twitter, Youtube, the newsletter, and Github',
};

const tellingStory = {
  title: 'Cilium - Get help telling your story about Cilium',
  description:
    'Are you passionate about Cilium and sharing your experience with the broader community? We want to help you tell your story!',
};

const newsletter = {
  title: 'Subscribe to bi-weekly eCHO News',
  description:
    'If you want to keep up on the latest in cloud native networking, observability, and security this is your source',
};

export { enterprise, learn, adopters, getHelp, getInvolved, tellingStory, newsletter, brand, homepage };
